import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

// Create a forward ref for the Link component
const Link = React.forwardRef(({ to, children, ...props }, ref) => {
  return <RouterLink to={to} {...props} ref={ref}>{children}</RouterLink>;
});

export default Link;
